import { render, staticRenderFns } from "./feather.vue?vue&type=template&id=4ee15544&"
import script from "./feather.vue?vue&type=script&lang=js&"
export * from "./feather.vue?vue&type=script&lang=js&"
import style0 from "./feather.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports